export {default as Tenants} from './tenants.vue'
export {default as Tenant} from './tenant.vue'